import { jsx as _jsx } from "react/jsx-runtime";
import { Loader } from '../../loader/loader';
// styles
import { LoaderWrapperStyled } from '../input.styled';
export const LoaderStandAlone = (props) => {
    return (_jsx(LoaderWrapperStyled, { styles: props.styles, children: _jsx(Loader, { variant: props.styles?.loaderVariant, visible: props.loading, width: props.styles?.loaderIcon?.width, ...props.loader }) }));
};
//# sourceMappingURL=loader.js.map